import _ from 'lodash';
import carWashCentreManagement from './carWashCentreManagement';
import consumptionStatistical from './consumptionStatistical';
import orderManagement from './orderManagement';
import staffManagement from './staffManagement';
import ticketsManagement from './ticketsManagement';
import settlementCenter from './settlementCenter';

export default _.union(
  carWashCentreManagement,
  consumptionStatistical,
  orderManagement,
  staffManagement,
  ticketsManagement,
  settlementCenter,
  [{
    name: 'carWashSuperviseSystem',
    path: '/carWashSuperviseSystem/:carWashId',
    meta: { title: '洗车监管系统' },
    component: require('views/common/blank.vue').default
  }]
);
